import React, { useCallback, useMemo } from 'react';
import { AccommodationsConsoleWithHealth } from '../../AccommodationsConsole';
import { HotelSearchMapLayout } from '@shared/constants/accommodations';
import type { ScenarioConsoleProps, ScenarioConfig } from '../scenarios.types';
import type { TopBarConfig } from '@shared/types/Accommodations.types';
import { GuestListingEntry } from '../components/listing-entry/GuestListingEntry';
import type { ScenarioListingEntryProps } from '../components/listing-entry/ListingEntry.types';

type GuestConsoleProps = Readonly<
  ScenarioConsoleProps & {
    layout?: HotelSearchMapLayout;
  }
>;

const GUEST_TOP_BAR: TopBarConfig = {
  searchForm: { dateRangeEnabled: true, occupancySelectorEnabled: true },
  showJoyLogo: true,
  showCloseButton: false,
};

export const GuestAccommodationsConsole = ({ eventHandle, eventName, onClose, selectedHotelId, layout = HotelSearchMapLayout.FULL }: GuestConsoleProps) => {
  const scenarioConfig = useMemo<ScenarioConfig>(() => ({ variant: 'guest', topBar: GUEST_TOP_BAR, mapLayoutMode: layout }), [layout]);

  const renderListingEntry = useCallback((props: ScenarioListingEntryProps) => <GuestListingEntry {...props} />, []);

  return (
    <AccommodationsConsoleWithHealth
      eventHandle={eventHandle}
      eventName={eventName}
      onClose={onClose}
      selectedHotelId={selectedHotelId}
      scenarioConfig={scenarioConfig}
      renderListingEntry={renderListingEntry}
    />
  );
};
